import API from '../config/axiosConfig';

class ConfigService {
  /**
   * Fetches configuration data from the API
   * @param {string} app - The application name (e.g., "test-tubes")
   * @param {string} config - The configuration type (e.g., "test-tubes")
   * @param {string} hospital - The hospital identifier (e.g., "emek")
   * @returns {Promise<any>} A promise resolving to the configuration data
   */
  static async getConfig(app, config, hospital) {
    try {
      const response = await API.get(`/api//configs/${app}/${config}/${hospital}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching config:', error);
      throw error;
    }
  }
}

export default ConfigService;